import {action} from "mobx";
import callService from "../services/callService";
import appStore from "./appStore";

class callStore {
    @action click2Call = async params => {
        try {
            const resultOfRequest = await callService.click2Call({
                courierId: params.courierId,
                phoneNumber: params.phoneNumber,
                priority: params.priority || "normal",
            });

            if (resultOfRequest.status !== 200) {
                const errorMessage = this.getDetailedErrorMessage(resultOfRequest.data);
                appStore.openErrorModal({content: errorMessage});
                return {success: false, message: errorMessage};
            }

            appStore.showSuccessMessage({
                content: "Arama başlatılma isteği gönderildi"
            });

            return {success: true, data: resultOfRequest.data.data};
        } catch (error) {
            console.error("Click2Call error:", error);
            const errorMessage = "Arama başlatılırken bir hata oluştu. Lütfen tekrar deneyin.";
            appStore.openErrorModal({content: errorMessage});
            return {success: false, message: errorMessage};
        }
    };

    @action checkCallStatus = async callRecordId => {
        try {
            const resultOfRequest = await callService.checkCallStatus(callRecordId);

            if (resultOfRequest.status !== 200) {
                const errorMessage = this.getDetailedErrorMessage(resultOfRequest.data);
                return {success: false, message: errorMessage};
            }

            return {success: true, data: resultOfRequest.data.data};
        } catch (error) {
            console.error("Call status check error:", error);
            return {success: false, message: "Arama durumu kontrol edilemedi"};
        }
    };

    /**
     * Backend'den gelen hata mesajlarını kullanıcı dostu hale getirir
     * @param {Object} errorData - Backend'den gelen hata verisi
     * @returns {string} Kullanıcı dostu hata mesajı
     */
    getDetailedErrorMessage(errorData) {
        if (!errorData) {
            return "Bilinmeyen bir hata oluştu. Lütfen tekrar deneyin.";
        }

        // Önce message alanını kontrol et
        if (errorData.message) {
            return errorData.message;
        }

        // Error code'a göre özel mesajlar
        if (errorData.errorCode) {
            const errorMessages = {
                "SESSION_NOT_FOUND_AND_LOGIN_FAILED": "Arama sistemi oturumu bulunamadı ve giriş yapılamadı. Lütfen teknik desteğe ulaşın.",
                "SESSION_EXPIRED_AND_LOGIN_FAILED": "Arama sistemi oturumu süresi dolmuş ve yeniden giriş yapılamadı. Lütfen teknik desteğe ulaşın.",
                "SESSION_CORRUPTED_AND_LOGIN_FAILED": "Arama sistemi oturum verisi bozuk ve yeniden giriş yapılamadı. Lütfen teknik desteğe ulaşın.",
                "SESSION_INVALID": "Arama sistemi oturumu geçersiz. Lütfen tekrar deneyin.",
                "EMAIL_REQUIRED": "Panel kullanıcısı email'i gerekli. Lütfen teknik desteğe ulaşın.",
                "PANEL_USER_LOGIN_FAILED": "Arama sistemi giriş yapılamadı. Lütfen teknik desteğe ulaşın.",
                "PANEL_USER_LOGIN_ERROR": "Arama sistemi ile bağlantı kurulamadı. Lütfen tekrar deneyin.",
                "INVALID_PHONE_NUMBER": "Geçersiz telefon numarası. Lütfen telefon numarasını kontrol edin.",
                "NO_AVAILABLE_USER": "AloTech'teki durumunuzu 'Hazır' olarak ayarlayın",
                "SYSTEM_BUSY": "Arama sistemi şu anda meşgul. Lütfen biraz bekleyin.",
                "NETWORK_ERROR": "Arama sistemi ile bağlantı kurulamadı. Lütfen tekrar deneyin.",
                "CALL_INITIATION_FAILED": "Arama başlatılamadı. AloTech'teki durumunuzu kontrol edin.",
                "UNEXPECTED_ERROR": "Beklenmeyen bir hata oluştu. Lütfen tekrar deneyin.",
                "STATUS_CHECK_ERROR": "Arama sistemi durumu kontrol edilemedi. Lütfen tekrar deneyin."
            };

            const message = errorMessages[errorData.errorCode];
            if (message) {
                // Eğer detay bilgisi varsa ekle
                if (errorData.details) {
                    return `${message}\n\nTeknik Detay: ${errorData.details}`;
                }
                return message;
            }
        }

        // Genel hata mesajı
        if (errorData.error) {
            return `Hata: ${errorData.error}`;
        }

        return "Bilinmeyen bir hata oluştu. Lütfen tekrar deneyin.";
    }
}

export default new callStore(); 